<template>
  <!-- 展映基地，基地详情 -->
  <div>
    <div class="container">
      <Bread :list="breadList" class="ma-t-30" />
      <div class="flex ma-t-30">
        <div class="width60">
          <el-carousel height="350">
            <el-carousel-item
              v-for="(src, index0) in detail.Images"
              :key="index0"
            >
              <div class="width100">
                <img
                  :src="src"
                  alt=""
                  srcset=""
                  width="100%"
                  height="100%"
                  class="img_cover"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="flex1 pa-20">
          <div class="font-bold fon-22">{{ detail.Name }}</div>
          <div class="ma-t-10">{{ detail.Summary }}</div>
          <div class="ma-t-10">
            <i class="el-icon-location-outline"></i>
            {{ detail.Address }}
          </div>
          <div class="ma-t-10">
            <i class="el-icon-location-outline"></i>
            {{ detail.Phone }} {{ detail.Contact }}
          </div>
        </div>
      </div>

      <div class="menu-item fon-24 ma-t-60">
          <div class="font-bold">展映活动</div>
          <div class="font-bold">Exhibition activities</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div>
            <div class="ma-t-30" v-for="(item,index) in detail.ActivityList" :key="index">
              <div class="flex">
                <img
                  :src="item.Image"
                  alt=""
                  srcset=""
                  width="380"
                  height="260"
                  class="img_cover b-r-15"
                />
                <div class="flex1 flex flex-direction pa-tb-10 f-between ma-l-20">
                  <div class="flex f-between">
                    <div class="fon-20 t-omit-1 c-p" :title="item.ActivityName" @click="
                        $router.push({
                          path: '/showing/activity/detail',
                          query: { id: item.Id,siteId:detail.Id },
                        })
                      ">{{ item.Name }}</div>
                    <!-- <div class="c-red font-bold fon-22">￥{{ item.Price }}</div> -->
                  </div>
                  <div class="c-666">
                    {{ item.Summary }}
                  </div>
                  <div class="c-666">
                    <i class="el-icon-time"></i>
                    {{ item.StartTime }} - {{ item.EndTime }}
                  </div>
                </div>
              </div>
              <div class="flex f-wrap ma-t-30">
                <div
                  class="box-item ma-b-0 t-center c-p"
                  v-for="(item2, index2) in item.MovieList"
                  :key="index2"
                >
                  <img
                    :src="item2.Image"
                    width="100%"
                    height="80%"
                    class="img_cover b-r-15"
                    alt=""
                    srcset=""
                  />
                  <div class="ma-t-20 t-omit-1">{{ item2.Name }}</div>
                </div>
              </div>
            </div>
            <Empty :isShow="detail.ActivityList.length==0"></Empty>
        </div>

        <div class="menu-item fon-24 ma-t-60">
          <div class="font-bold">详细介绍</div>
          <div class="font-bold">Detailed introduction</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div class="li-html pa-tb-20" v-html="detail.Content"></div>
        <Empty :isShow="!detail.Content"></Empty>
    </div>
  </div>
</template>

<script>
import { getShowingSiteDetail } from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "翠麟点映",
          path: "/showing/site/index",
        },{
          name: "详情",
          path: "/showing/site/detail",
        },
      ],
      detail: {},
      id: 0,
    };
  },
  activated() {
    this.id = this.$route.query.id;
    this.loadData();
  },
  methods: {
    loadData() {
      getShowingSiteDetail({ id: this.id }).then((res) => {
        this.detail = res.data.Data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}


.box-item {
  width: 18%;
  height: 320px;
}
.box-item:not(:nth-child(5n)) {
  margin-right: calc(10% / 5);
}

</style>